/* eslint-disable react-hooks/exhaustive-deps, jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  TextField,
  CardContent,
  Divider,
  Checkbox,
  FormControlLabel,
  Menu,
  MenuItem,
  Snackbar,
  Alert,
  AlertTitle,
  Select,
  Input,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTheme } from "../../style/theme";
import loader from "../../assets/loader.gif";
// import { formatDateToReadable } from "../../utilities/helper";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { GrCreditCard } from "react-icons/gr";
import axios from "axios";
import { useUser } from "../../hooks/Authorize";
import master from "../../assets/cards/master.png";
import visa from "../../assets/cards/visa.png";
import union from "../../assets/cards/union.png";
import amex from "../../assets/cards/amex.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const PlanDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [userError, setUserError] = useState(false);

  const platformUser = useUser();
  const { mode } = useTheme();
  const selectedPlan = location.state?.plan;
  const selectedInterval = location.state?.selectedPlan;

  // const [intervals,setIntervals] = useState(selectedInterval);
  // const [getplan, setGetplan] = useState(location.state?.plan);
  // const currDate = new Date();
  //  // const [nextBillingDate, setNextBillingDate] = useState("");
  const stripe = useStripe();
  const elements = useElements();
  const [billingType, setBillingType] = useState(selectedInterval);
  const organizationId = localStorage.getItem("orgId");
  const [cardHolderName, setCardHolderName] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [Selectorloading, setSelectorloading] = useState(false);
  const [selected, setSelected] = useState(selectedPlan?.name);
  const [finalPlan, setFinalPlan] = useState(selectedPlan);
  const [numberOfUser, setNumberOfUser] = useState(5);
  const [subscriptionUser, setSubscriptionUser] = useState(null);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (text) => {
    setSelected(text);
    handleClose();
  };

  const getPlans = async (interval) => {
    try {
      const response = await axios.get(
        `/store/plan/chat?interval=${interval}`
      );
      const fetchedPlans = response.data.data;
      setPlans(fetchedPlans);
    } catch (error) {
      console.error("Failed to fetch plans:", error);
    } finally {
    }
  };

  const getPlanDetails = async () => {
    setSelectorloading(true); // 👈 start loading
    console.log(Selectorloading, "interval");
    try {
      const response = await axios.post(`/store/plan/detail`, {
        name: selected,
        interval: billingType === "Monthly plans" ? "month" : "year",
        type: "chat",
      });
      const fetchPlan = response?.data?.data;
      setFinalPlan(fetchPlan);
      setSelectorloading(false); // 👈 stop loading
    } catch (error) {
      console.error("Failed to fetch organizations:", error);
    } finally {
      setSelectorloading(false); // 👈 stop loading
    }
  };

  // const handlePurchase = () => {
  //   // Handle purchase logic
  //   console.log("Purchase clicked");
  // };
  // const billingCycleAmount =
  //   billingCycle === "Yearly" ? selectedPlan.amount * 12 : selectedPlan.amount;

  // const [formData, setFormData] = useState({
  //   noOfUsers: "",
  //   Cases: false,
  //   "Extra Reports": false,
  //   "Employee Engagement": false,
  //   support: "",
  //   apiCalls: "",
  //   extraForms: "",
  //   extraStorage: "",
  //   jumpStart: "",
  // });

  // const [name, setName] = useState("");
  const [showMessage, setShowMessage] = useState({
    show: false,
    message: "",
    severity: "",
  });

  const handleChange = (event) => {
    setBillingType(event.target.value);
  };
  // const handleChange = (label, value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [label]: value,
  //   }));
  // };

  const calculateNextBillingDate = () => {
    const date = new Date();
    if (billingType === "Yearly") {
      date.setFullYear(date.getFullYear() + 1);
    } else {
      date.setMonth(date.getMonth() + 1);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps

  // const calculateTotal = () => {
  // Implement addon total calculation logic if needed
  //   return 0;
  // };

  // const handleChangeNext = () => {
  //   const totalAddons = calculateTotal();
  //   const subscriptionSummary = {
  //     plan: selectedPlan,
  //     billingCycle,
  //     billingCycleAmount,
  //     adonsData: formData,
  //     nextBillingDate,
  //     currDate: formatDateToReadable(currDate),
  //     totalAmount: billingCycleAmount + totalAddons,
  //   };

  //   navigate("/pay-step", { state: { subscriptionSummary } });
  // };

  const getSubscription = async () => {
    // setLoadingPlans(true); // 👈 start loading
    try {
      const response = await axios.post(`/subscription/check-chat`, {
        orgId: organizationId,
        userId: platformUser?._id,
      });
      const subscription = response.data.subscription;
      localStorage.setItem("subscription", JSON.stringify(subscription));
      setSubscriptionUser(subscription?.plan?.name);
    } catch (error) {
      console.error("Failed to fetch plans:", error);
    } finally {
      // setLoadingPlans(false); // 👈 stop loading
    }
  };

  useEffect(() => {
    getPlanDetails();
    calculateNextBillingDate();
    getPlans("month");
    getSubscription();
  }, [billingType, selected]);
  const handleBackClick = () => {
    navigate(-1);
  };

  const [isBusiness, setIsBusiness] = useState(false);
  const [ispurchase, setispurchase] = useState(false);
  const [Adress, setAddress] = useState({
    companyName: "",
    address: "",
    city: "",
  });

  const handleAddess = (e) => {
    const { name, value } = e.target;

    setAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCloseToast = () => {
    setShowMessage({ show: false, message: " ", severity: "" });
  };
  const handleSubmit = async (event) => {
    event.preventDefault(); // ✅ Always first

    // 🔴 New logic: Validate numberOfUser before anything
    if (Number(numberOfUser) < 5 || numberOfUser === "") {
      setUserError(true); // optional: red border or inline error
      setShowMessage({
        show: true,
        message: "Please enter at least 5 users.",
        severity: "warning",
      });
      return; // 🔴 Stop here — do not proceed to Stripe
    } else {
      setUserError(false); // clear previous error if any
    }

    setLoading(true); // ✅ Moved here: only trigger when valid

    if (!cardHolderName || !stripe || !elements) {
      setShowMessage({
        show: true,
        message: "Please complete all card details and enter your name.",
        severity: "warning",
      });
      setLoading(false);
      return;
    }

    const cardElement = elements.getElement(CardNumberElement);

    const { error: paymentError, paymentMethod } =
      await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
      });

    if (paymentError) {
      setShowMessage({
        show: true,
        message: "Error creating payment method",
        severity: "error",
      });
      setLoading(false);
      return;
    }

    const { token, error: tokenError } = await stripe.createToken(
      cardElement,
      {}
    );

    if (tokenError) {
      setShowMessage({
        show: true,
        message: "Error creating token",
        severity: "error",
      });
      setLoading(false);
      return;
    }

    const payload = {
      userId: platformUser?._id || "",
      name: platformUser?.firstName || "",
      email: platformUser?.recoveryEmail || platformUser?.email || "",
      paymentMethod: paymentMethod.id,
      tokenId: token.id,
      card: token.card,
      plan: finalPlan.name,
      amount: finalPlan.amount,
      planId: finalPlan._id,
      companyName: Adress.companyName,
      address: Adress.address,
      city: Adress.city,
      addons: { noOfUsers: numberOfUser },
      orgId: organizationId,
    };

    try {
      const response = await axios.post(
        `/store/subscription/chat?userId=${platformUser?._id}`,
        payload
      );

      if (response.status === 200) {
        setShowMessage({
          show: true,
          message: "Subscribe Successfully",
          severity: "success",
        });
        setLoading(false);
        window.location.replace("https://chat.clikkle.com");
        // navigate("/");
      }
    } catch (e) {
      console.error(e);
      setLoading(false);
      setShowMessage({
        show: true,
        message: "Error creating subscription",
        severity: "error",
      });
    }
  };

  const cardStyle = {
    style: {
      base: {
        fontSize: "16px",
        color: mode === "light" ? "#000" : "#ffffff",
        "::placeholder": { color: "#a5a5a5" },
      },
      invalid: { color: "#fa755a" },
    },
    placeholder: "Card Number",
  };
  const ExpireStyle = {
    style: {
      base: {
        fontSize: "16px",
        color: mode === "light" ? "#000" : "#ffffff",
        "::placeholder": { color: "#a5a5a5" },
      },
      invalid: { color: "#fa755a" },
    },
    placeholder: "Expiration Date (MM/YY)",
  };
  const CVCStyle = {
    style: {
      base: {
        fontSize: "16px",
        color: mode === "light" ? "#000" : "#ffffff",
        "::placeholder": { color: "#a5a5a5" },
      },
      invalid: { color: "#fa755a" },
    },
    placeholder: "Security Code",
  };

  if (!selectedPlan) {
    return (
      <Box
        sx={{
          backgroundColor: "#121212",
          color: "#fff",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{ color: mode === "light" ? "black" : "#E53935" }}
        >
          Plan not found! Please check the URL.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        overflow: "visible",
        height: "90%",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginTop: "0px",
      }}
    >
      <Snackbar
        open={showMessage.show}
        autoHideDuration={4000}
        onClose={handleCloseToast}
      >
        <Alert
          severity={showMessage.severity}
          variant="filled"
          sx={{ width: "100%" }}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <AlertTitle> {showMessage.severity}</AlertTitle>
          {showMessage.message}
        </Alert>
      </Snackbar>
      <Box>
        <Button
          onClick={handleBackClick}
          sx={{
            color: mode === "light" ? "#26272C" : "#FFFFFF",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            borderRadius: "5px",
          }}
        >
          <ArrowBackIcon sx={{ marginRight: "0.5rem" }} />
        </Button>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
          height: "90vh",
          py: 2,
        }}
      >
        <Grid
          container
          spacing={0.2}
          sx={{
            maxWidth: "80%",
            width: "100%",
            borderRadius: "12px",
            height: "80vh",
          }}
        >
          {/* Payment Form Section */}
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              height: "80%",
            }}
          >
            <Grid
              item
              sx={{
                height: "75vh",
                overflowY: "auto",
                py: 1,
                scrollbarwidth: "none",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  display: "none",
                  width: "80%",
                },
              }}
            >
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "30px",
                    fontWeight: "bold",
                    mb: 2,
                    maxWidth: "500px",
                    margin: "0 auto",
                    pb: 4,
                  }}
                >
                  Choose how to pay
                </Typography>
                <Box
                  sx={{
                    border: "2px solid #0285FF",
                    borderRadius: "25px", // Adjusted to match the rounded border style
                    padding: "25px",
                    maxWidth: "500px",
                    margin: "0 auto",
                  }}
                >
                  <Box display="flex" alignItems="center" mb={2}>
                    <GrCreditCard size={20} />
                    <Typography
                      variant="h6"
                      sx={{ ml: 2, fontSize: "16px", fontWeight: "bold" }}
                    >
                      Card
                    </Typography>
                  </Box>
                  <Grid container spacing={2} direction="column">
                    {/* Card Number Element */}
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: "30px", // Rounded border for the input
                          p: 1.5,
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          width: "100%",
                        }}
                      >
                        <Box sx={{ flexGrow: 1 }}>
                          <CardNumberElement options={cardStyle} />
                        </Box>
                        <Box display="flex" gap="5px">
                          <img
                            src={master}
                            alt="master"
                            style={{ width: 24, height: 14 }}
                          />
                          <img
                            src={visa}
                            alt="visa"
                            style={{ width: 24, height: 14 }}
                          />
                          <img
                            src={amex}
                            alt="Amex"
                            style={{ width: 24, height: 14 }}
                          />
                          <img
                            src={union}
                            alt="union"
                            style={{ width: 24, height: 14 }}
                          />
                        </Box>
                      </Box>
                    </Grid>

                    {/* Expiration Date Element */}
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: "30px", // Rounded border for the input
                          p: 1.5,
                          width: "100%",
                        }}
                      >
                        <CardExpiryElement options={ExpireStyle} />
                      </Box>
                    </Grid>

                    {/* CVC Element */}
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: "30px", // Rounded border for the input
                          p: 1.5,
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          width: "100%",
                        }}
                      >
                        <Box sx={{ flexGrow: 1 }}>
                          <CardCvcElement options={CVCStyle} />
                        </Box>
                        <GrCreditCard size={20} />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              <Box sx={{ pr: 2, mt: 1 }}>
                <Box
                  sx={{
                    borderRadius: "10px",
                    padding: "20px",
                    maxWidth: "500px",
                    margin: "0 auto",
                  }}
                >
                  <Divider sx={{ mb: 4 }} />
                  <TextField
                    fullWidth
                    placeholder="Card Holder Name"
                    variant="outlined"
                    value={cardHolderName}
                    onChange={(e) => setCardHolderName(e.target.value)}
                    sx={{ mb: 2 }}
                    InputProps={{
                      sx: {
                        borderRadius: "20px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "20px",
                        },
                      },
                    }}
                  />

                  {/* <Grid container spacing={2}>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        borderRadius: "20px",
                      }}
                    >
                      <TextField
                        fullWidth
                        placeholder="Zip code"
                        variant="outlined"
                        InputProps={{
                          sx: {
                            borderRadius: "20px", // THIS works on the root
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderRadius: "20px", // THIS applies to the visible outline
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        borderRadius: "20px",
                      }}
                    >
                      {/* <Typography
                        variant="h6"
                        sx={{ fontSize: "16px", fontWeight: "bold", mb: 1 }}
                      >
                        Country
                      </Typography> */}
                  {/* <TextField
                        fullWidth
                        placeholder="Country"
                        variant="outlined"
                        InputProps={{
                          sx: {
                            borderRadius: "20px", // THIS works on the root
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderRadius: "20px", // THIS applies to the visible outline
                            },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>  */}

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isBusiness}
                        onChange={(e) => {
                          setIsBusiness(e.target.checked);
                          setispurchase(!ispurchase);
                        }}
                      />
                    }
                    label="I am purchasing for a business"
                    sx={{ mt: 2, mb: 2 }}
                  />

                  {ispurchase ? (
                    <>
                      <TextField
                        fullWidth
                        name="companyName"
                        value={Adress.companyName}
                        onChange={handleAddess}
                        placeholder="Company name"
                        variant="outlined"
                        sx={{ mb: 2 }}
                        InputProps={{
                          sx: {
                            borderRadius: "20px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderRadius: "20px",
                            },
                          },
                        }}
                      />

                      <TextField
                        fullWidth
                        name="address"
                        value={Adress.address}
                        onChange={handleAddess}
                        placeholder="Address"
                        variant="outlined"
                        sx={{ mb: 2 }}
                        InputProps={{
                          sx: {
                            borderRadius: "20px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderRadius: "20px",
                            },
                          },
                        }}
                      />

                      <TextField
                        fullWidth
                        name="city"
                        value={Adress.city}
                        onChange={handleAddess}
                        placeholder="City"
                        variant="outlined"
                        sx={{ mb: 2 }}
                        InputProps={{
                          sx: {
                            borderRadius: "20px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderRadius: "20px",
                            },
                          },
                        }}
                      />
                    </>
                  ) : (
                    ""
                  )}

                  <Divider sx={{ my: 2 }} />

                  <Box sx={{ mt: 2 }}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "14px", color: "#555", mb: 1 }}
                    >
                      By purchasing a plan you agree that you have read,
                      understand and agree to be bound by the{" "}
                      <a
                        href="#"
                        style={{ textDecoration: "none", color: "#0066cc" }}
                      >
                        Store Service
                      </a>{" "}
                      and{" "}
                      <a
                        href="#"
                        style={{ textDecoration: "none", color: "#0066cc" }}
                      >
                        Privacy Statement.
                      </a>
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "14px", color: "#555" }}
                    >
                      After the first{" "}
                      {billingType === "Yearly Plans" ? "year" : "month"}, your
                      subscription will renew and your payment method will be
                      charged USD $
                      {(numberOfUser > 0
                        ? Number(finalPlan?.amount) * Number(numberOfUser)
                        : Number(finalPlan?.amount)
                      ).toFixed(2)}{" "}
                      unless you cancel. You can cancel anytime through your
                      account settings.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignitems: "center",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#0066FF",
                  color: "#fff",
                  borderRadius: "15px",
                  padding: "12px 0",
                  mt: 3,
                  "&:hover": { backgroundColor: "#0055cc" },
                  width: "50%",
                }}
                onClick={handleSubmit}
              >
                {loading ? (
                  <img src={loader} width={18} height={18} alt="Loading..." />
                ) : (
                  `Chat ${finalPlan.name}`
                )}
              </Button>
            </Box>
          </Grid>

          {/* Plan Summary Section */}
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              height: "80%",
              overflow: "visible",
              width: "100%",
              backgroundColor: mode === "light" ? "#fff" : "#141414",
            }}
          >
            <Box
              sx={{
                position: "relative",
                borderRadius: "16px",
                overflow: "hidden",
                p: 0.5,
                backgroundColor: mode === "light" ? "#fff" : "#141414",
              }}
            >
              <div
                sx={{
                  borderRadius: "16px",
                  boxShadow: "none",
                  backgroundColor: mode === "light" ? "white" : "#141414",
                  width: "100%",
                  height: "100%",
                  p: 2,
                  border: "2px solid rgb(236, 225, 225)",
                }}
              >
                <CardContent>
                  {/* Plan Summary Content */}
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6B7280",
                      fontWeight: 500,
                      fontSize: "14px",
                      mb: 1,
                    }}
                  >
                    Your plan
                  </Typography>
                  <>
                    <Box
                      onClick={handleOpen}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                        fontWeight: 700,
                        fontSize: "26px",
                        color: mode === "light" ? "#000" : "#fff",
                        fontFamily: "Canela",
                        userSelect: "none",
                        width: "100%",
                      }}
                    >
                      Chat {finalPlan.name}
                      <KeyboardArrowDownIcon sx={{ ml: 1 }} />
                    </Box>

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {plans.map((plan) => (
                        <MenuItem
                          key={plan.id}
                          onClick={() => handleSelect(plan.name)}
                          disabled={plan.name === subscriptionUser}
                        >
                          Chat {plan.name}
                        </MenuItem>
                      ))}
                    </Menu>
                  </>
                  <Typography
                    sx={{
                      fontSize: "14px",

                      mb: 4,
                      color: mode === "light" ? "#111" : "#FFFF",
                    }}
                  >
                    store workspace
                  </Typography>
                  <Divider sx={{ my: 2 }} />
                  {/* Billing Cycle Section */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ my: 4 }} // Adjusted vertical spacing
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",

                        mb: 3,
                        color: mode === "light" ? "#111" : "#FFFF",
                      }}
                    >
                      Billing cycle
                    </Typography>
                    <Select
                      value={
                        billingType === "Yearly Plans" ? "Yearly" : billingType
                      }
                      onChange={handleChange}
                      variant="standard"
                      disableUnderline
                      sx={{
                        backgroundColor: "transparent",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: mode === "light" ? "#000" : "#fff",
                        cursor: "pointer",
                        mb: 3,
                        "& .MuiSelect-select": {
                          padding: 0,
                          backgroundColor: "transparent", // default transparent inside select
                        },
                        "&.Mui-focused .MuiSelect-select": {
                          backgroundColor: "transparent", // transparent when focused
                        },
                      }}
                    >
                      <MenuItem value="Monthly plans">Monthly</MenuItem>
                      <MenuItem value="Yearly">Yearly</MenuItem>
                    </Select>
                  </Box>
                  {/* Pricing Breakdown */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ my: 3 }} // Adjusted vertical spacing
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",

                        mb: 3,
                        color: mode === "light" ? "#111" : "#FFFF",
                      }}
                    >
                      {Selectorloading ||
                      !billingType ||
                      finalPlan.amount === null ? (
                        <img
                          src={loader}
                          width={12}
                          height={12}
                          alt="Loading..."
                        />
                      ) : (
                        <>
                          {billingType === "Monthly plans"
                            ? finalPlan.amount
                            : (finalPlan.amount / 12).toFixed(2)}
                          x{billingType === "Monthly plans" ? 1 : 12} month
                        </>
                      )}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        mb: 3,
                        color: mode === "light" ? "#111" : "#FFFF",
                      }}
                    >
                      {finalPlan.amount}
                    </Typography>
                  </Box>
                  {/* Number Of Users*/}
                  {/* <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ my: 3 }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: mode === "light" ? "#2F855A" : "white",
                        fontWeight: "500",
                      }}
                    >
                      Number Of Users
                    </Typography>
                    <Input
                      value={numberOfUser}
                      variant="outlined"
                      onChange={(e) => setNumberOfUser(e.target.value)}
                      sx={{
                        border: "1px solid white",
                        borderRadius: "14px",
                        paddingLeft: "10px",
                        outline: "none",
                        width: "100px",
                      }}
                    />
                  </Box> */}
                  <Box display="flex" flexDirection="column" sx={{ my: 3 }}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: mode === "light" ? "#2F855A" : "white",
                          fontWeight: "500",
                        }}
                      >
                        Number Of Users
                      </Typography>
                      <Input
                        value={numberOfUser}
                        type="number"
                        variant="outlined"
                        onChange={(e) => {
                          const value = e.target.value;
                          setNumberOfUser(value);
                          setUserError(Number(value) < 5);
                        }}
                        sx={{
                          border: "1px solid white",
                          borderRadius: "14px",
                          paddingLeft: "10px",
                          outline: "none",
                          width: "100px",
                        }}
                      />
                    </Box>

                    {/* 👇 Error message if input < 5 */}
                    {userError && (
                      <Typography
                        sx={{ color: "red", fontSize: "12px", mt: 1 }}
                      >
                        Minimum 5 users required
                      </Typography>
                    )}
                  </Box>
                  {/* <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ my: 3 }} // Adjusted vertical spacing
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: mode === "light" ? "#2F855A" : "#9dedc5",
                        fontWeight: "500",
                        mb: 3,
                      }}
                    >
                      17% off yearly
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: mode === "light" ? "#2F855A" : "#9dedc5",
                      }}
                    >
                      - $48
                    </Typography>
                  </Box> */}
                  {/* Promo Code Section */}
                  {/* <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ my: 3 }} // Adjusted vertical spacing
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",

                        color: mode === "light" ? "#111" : "#FFFF",
                      }}
                    >
                      Promo code
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: mode === "light" ? "#111" : "#FFFF",

                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      Add
                    </Typography>
                  </Box> */}
                  <Divider sx={{ my: 3 }} /> {/* Adjusted divider spacing */}
                  {/* Total Amount Section */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ my: 3 }} // Adjusted vertical spacing
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",

                        fontWeight: "500",
                        color: mode === "light" ? "#111" : "#FFFF",
                      }}
                    >
                      Today's total
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",

                        fontWeight: "bold",
                        color: mode === "light" ? "#111" : "#FFFF",
                      }}
                    >
                      $
                      {numberOfUser > 0
                        ? Number(finalPlan?.amount) * Number(numberOfUser)
                        : Number(finalPlan?.amount)}
                    </Typography>
                  </Box>
                </CardContent>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PlanDetails;
